import styled from 'styled-components';

export const AuthWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 96px);
    padding: var(--space-6) var(--space-4);
    background:
        radial-gradient(ellipse 80% 50% at 50% -20%, rgba(66, 69, 108, 0.45), transparent 60%),
        transparent;
`;
